export default __webpack_public_path__ + "static/media/twitter-icon.eb263c16.svg";